import { on } from '@ember/modifier';
import { and, not } from 'tio-ui/utilities';
import { Section } from 'tio-ui/components/layout';
import { t } from 'ember-intl';
import Button from 'tio-reimagined/components/button';
import Component from '@glimmer/component';
import TioAlert from 'tio-common/components/tio/alert';
import UploadAttachments from 'tio-common/components/tuition-assistance/forms/upload-attachments';
import type TasApplicationModel from 'tio-common/models/tas-application';
import type TasProgramTemplateModel from 'tio-common/models/tas-program-template';

interface StepAttachmentsSignature {
  Args: {
    stepNumber: number;
    application: TasApplicationModel;
    programTemplate: TasProgramTemplateModel;
    attachmentClassificationString: string;
    attachmentsListInstructions: string;
    attachmentsListItems: string[];
    isAttachmentRequired: boolean;
    hasRequiredAttachments: boolean;
    onNext: () => void;
    hasAttempted: boolean;
    isComplete: boolean;
  };
}

export default class StepAttachments extends Component<StepAttachmentsSignature> {
  get displayNumber() {
    return this.args.stepNumber + 1;
  }

  <template>
    <Section>
      <:header>
        <div class="flex items-center gap-2">
          <span
            class="inline-flex items-center justify-center w-7 h-7 rounded-full bg-violet-600 text-white text-xs font-bold"
          >{{this.displayNumber}}</span>
          <span>
            {{t "tas.guided.steps.include_attachments"}}
            {{#if @isAttachmentRequired}}
              <span class="text-error-400">*</span>
            {{/if}}
          </span>
        </div>
      </:header>
      <:body>
        {{#if (and @hasAttempted @isAttachmentRequired (not @hasRequiredAttachments))}}
          <TioAlert @type="error" @allowDismiss={{false}} class="mb-4">
            <:body>
              <p class="text-sm font-medium">{{t "tas.guided.steps.attachments_required"}}</p>
            </:body>
          </TioAlert>
        {{/if}}

        <UploadAttachments
          @programTemplate={{@programTemplate}}
          @classification={{@attachmentClassificationString}}
          @attachable={{@application}}
          @attachableType="tasApplication"
          @useDropzone={{true}}
          @instructions={{@attachmentsListInstructions}}
          @items={{@attachmentsListItems}}
        />

        {{! Next button }}
        <div class="flex pt-8">
          <Button @intent="primary" data-test-next-step {{on "click" @onNext}}>
            {{t "common.next"}}
          </Button>
        </div>
      </:body>
    </Section>
  </template>
}
